import {
  getCardError,
  getCardNameError
} from '@jarvis.oddle/core/tools/validation'
import { paymentMethods, paymentTypes } from 'src/utils/payment'
import { isObjectEmpty } from 'src/utils/object'

interface ResponseType {
  cardName?: string
  card?: string
}

interface PaymentMethods extends Oms.V4.PaymentMethodData {
  parsedId?: string
}

export const validateCard = ({
  t,
  cardName,
  card,
  selectedPaymentMethod,
  isEnabledCustomerSaveCreditCardOnStripe = false,
  selectedSavedCreditCard = null
}: {
  t: (x) => string
  cardName: string
  card: {
    error: {
      message: string
    }
  }
  selectedPaymentMethod: PaymentMethods
  isEnabledCustomerSaveCreditCardOnStripe?: boolean
  selectedSavedCreditCard?: Oms.V4.SelectedSavedCreditCard
}): ResponseType => {
  const errors = {} as ResponseType
  switch (selectedPaymentMethod.type) {
    case paymentTypes.stripe:
      if (!selectedPaymentMethod.stripeRequestPayment) {
        const cardNameError = getCardNameError(t, cardName)
        if (cardNameError) errors.cardName = cardNameError
        const cardError = card.error?.message
        if (cardError) errors.card = cardError
      }
      break
    case paymentTypes.stripeExpressAccount:
      if (
        isEnabledCustomerSaveCreditCardOnStripe &&
        !isObjectEmpty(selectedSavedCreditCard) &&
        selectedPaymentMethod.paymentMethod !== paymentMethods.FPX &&
        selectedPaymentMethod.stripeRequestPaymentButtonType !==
          paymentMethods.APPLE_PAY
      ) {
        break
      }
      if (!selectedPaymentMethod.stripeRequestPayment) {
        const cardNameError = getCardNameError(t, cardName)
        if (cardNameError) errors.cardName = cardNameError
        const cardError = card.error?.message
        if (cardError) errors.card = cardError
      }
      break
    case paymentTypes.chinatrust:
      if (!selectedPaymentMethod.isEnabledChinatrustRedirect) {
        const cardNameError = getCardNameError(t, cardName)
        if (cardNameError) errors.cardName = cardNameError
        const cardError = getCardError(t, card)
        if (cardError) errors.card = cardError
      }
      break
  }

  return errors
}
